import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { getPaginationCasts, getPaginationInject } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: 'five-thresholds-coefficients',
  name: 'fiveThresholdsCoefficients',
  component: () =>
    import(
      /* webpackChunkName: "five-thresholds-coefficients" */ 'pages/order-bot/FiveThresholdsCoefficients.vue'
    ),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.order_bot.five_thresholds_coefficients'),
      icon: 'mdi-numeric-5-box-multiple-outline',
    },
    auth: {
      permission: 'order_bot_manage',
    },
    inject: {
      query: {
        ...getPaginationInject(),
        sort: 'updated_at',
        dir: 'desc',
      },
    },
    casts: {
      query: {
        ...getPaginationCasts(),
      },
    },
  },
  children: [
    {
      path: 'upload-five-thresholds-coefficients',
      name: 'uploadFiveThresholdsCoefficients',
      component: () =>
        import(
          /* webpackChunkName: "upload-five-thresholds-coefficients" */ 'pages/order-bot/UploadFiveThresholdsCoefficients.vue'
        ),
      meta: {
        breadcrumb: {
          icon: 'mdi-numeric-5-box-multiple-outline',
          name: t('breadcrumb.order_bot.upload_five_thresholds_coefficients'),
        },
        auth: {
          permission: 'order_bot_manage',
        },
        casts: {
          query: {},
        },
      },
    },
  ],
}

export default module
